import React from 'react';
import UserAvatar from '@components/UserAvatar';
import './AssigneeUserItem.less';
import { ReactComponent as UpgradePlanSvg } from '@assets/icons/diamond-upgrade.svg';
import { ReactComponent as CloseSvg } from '@assets/icons/cross.svg';
import { AWStageMemberDecisionDto, MemberDto, MemberUserDto } from '@api/Api';

type User = Omit<MemberUserDto, 'name'> & { name?: string | null };
type UserData =
  | { user: User }
  | { invitationEmail: string; user?: null }
  | MemberDto;

export default function AssigneeUserItem({
  userData,
  needUpdatePlan = false,
  isShowDecision,
  decision
}: {
  userData: UserData;
  needUpdatePlan?: boolean;
  isShowDecision?: boolean;
  decision?: AWStageMemberDecisionDto;
}) {
  return (
    <>
      {!!userData.user && (
        <div className="assigned-users-menu-item">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 15,
              maxWidth: '100%'
            }}
          >
            <UserAvatar
              isActive
              size="large"
              src={userData.user.picture.url || ''}
              userEmail={userData.user.email || ''}
              userName={userData.user.name || ''}
              isShowDecision={isShowDecision}
              decision={decision}
            />
            <div className="assigned-users-menu-item--name">
              <span>{userData?.user?.name}</span>
              <span>{userData?.user?.email}</span>
            </div>
            {needUpdatePlan && <UpgradePlanSvg />}
          </div>
          <CloseSvg className="close-icon" />
        </div>
      )}
      {!userData.user && (
        <div className="assigned-users-menu-item">
          <UserAvatar
            isActive={false}
            size="large"
            src=""
            userEmail={userData.invitationEmail ?? ''}
            userName={userData.invitationEmail ?? ''}
          />
          <span
            className="assigned-users-menu-item--name"
            style={{
              fontSize: 12,
              fontWeight: 400,
              display: 'block',
              color: '#969696',
              flex: 'auto'
            }}
          >
            {userData.invitationEmail}
          </span>
          {needUpdatePlan && <UpgradePlanSvg style={{ flex: 'none' }} />}
        </div>
      )}
    </>
  );
}
